<div
  [ngClass]="
    layoutMode() === 'fullWidth' ? 'w-full' : 'w-full md:w-[60vw] lg:w-[30vw]'
  "
>
  <div class="flex w-full flex-col items-center justify-center">
    <!-- Title and Subtitle -->
    @if (showHeader()) {
      <div class="mb-8 w-full text-left">
        <h2 class="text-4xl leading-tight font-medium text-primary-text">
          <span [innerHTML]="title()"></span>
        </h2>
        <p class="text-base leading-normal font-normal text-primary-text">
          <span [innerHTML]="subtitle()"></span>
        </p>
      </div>
    }
  </div>
  <div class="flex flex-col gap-6">
    <ng-content select="before-form"></ng-content>
    @if (formGroup()) {
      <form
        class="flex w-full flex-col gap-4"
        [formGroup]="formGroup()!"
        (ngSubmit)="onSubmitClick()"
      >
        @if (serverError(); as error) {
          <div
            class="mb-4 w-full rounded-md bg-red-50 p-4 text-sm text-red-500"
            role="alert"
          >
            <span>{{ error.key | translate: error.params }}</span>
          </div>
        }
        <ng-content select="form"></ng-content>
        <!-- Submit Button -->
        @if (submitAction() && submitText()) {
          <button
            class="btn-primary relative mt-6 btn h-12 w-full"
            [disabled]="isLoading() || formGroup().invalid"
            [class.opacity-50]="isLoading()"
            type="submit"
          >
            @if (!isLoading()) {
              <span>
                {{ submitText() }}
              </span>
            }
            @if (isLoading()) {
              <span class="flex items-center justify-center gap-2">
                <svg class="h-5 w-5 animate-spin" viewBox="0 0 24 24">
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                    fill="none"
                  />
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                {{ 'common.loading.submitting' | translate }}
              </span>
            }
          </button>
        }
      </form>
    }
    <div
      class="flex flex-col gap-6"
      [class.items-center]="layoutMode() !== 'fullWidth'"
    >
      <ng-content select="after-button"></ng-content>
      <ng-content select="links"></ng-content>
    </div>
  </div>
</div>
